import { lentComponent, useContractMutation, useContractQuery } from "@amtana/browser";
import type { LentToken, MutationResult, QueryResult } from "@amtana/browser";
import { pushTrpcContract } from "@amtana/push-contract";
import type {
  PushSubscriptionSummary,
  SubscribeInput,
  UnsubscribeInput,
  UnsubscribeOutput,
  VapidPublicKey,
} from "@amtana/push-contract";

// Web push (S7.04) for every browser module: the server's VAPID public key,
// and subscribing or unsubscribing this device.

export function useVapidPublicKey(): QueryResult<VapidPublicKey> {
  return useContractQuery(pushTrpcContract, "vapidPublicKey", { input: {} });
}

export function useSubscribePush(): MutationResult<PushSubscriptionSummary, SubscribeInput> {
  const mutation = useContractMutation(pushTrpcContract, "subscribe");
  return { ...mutation, run: (input) => mutation.mutateAsync(input) };
}

export function useUnsubscribePush(): MutationResult<UnsubscribeOutput, UnsubscribeInput> {
  const mutation = useContractMutation(pushTrpcContract, "unsubscribe");
  return { ...mutation, run: (input) => mutation.mutateAsync(input) };
}

/** The settings screen's "this device" control, lent so notification never reads push's data
 * itself (modules.md § How modules talk). */
export const PushDeviceControl: LentToken<Record<string, never>> = lentComponent<Record<string, never>>(
  "push",
  "PushDeviceControl",
);
